

<div class="container-fluid my-profile zero-padding">

  <div *ngIf="displayRoleMatrix">
    <vs-role-matrix (closeRolesMatrixEvent)="closeRolesMatrixOverlay($event)"></vs-role-matrix>
  </div>
  
  <div class="row custom-update-msg">
    <div class="col-md-12">
      <p class="my-profile-header-message">
        {{ "myProfile.myProfileHeaderMesage" | cxTranslate }}
      </p>
    </div>
  </div>
  <div class="tab">
    <button
      class="tablinks"
      id="defaultOpen" #defaultOpen
      (click)="openProduct($event, 'categoryOne'); clear(messageType.MSG_TYPE_CONFIRMATION); clear(messageType.MSG_TYPE_INFO)"
    >
      <i class="material-icons custom-margin-right-icon">account_circle</i>
      {{ "myProfile.personalDetail" | cxTranslate }}
    </button>
    <button class="tablinks" (click)="openProduct($event, 'categoryTwo'); clear(messageType.MSG_TYPE_INFO); clear(messageType.MSG_TYPE_CONFIRMATION);">
      <i class="material-icons custom-margin-right-icon">group</i>
      {{ "myProfile.customerIcon" | cxTranslate }}
    </button>
    <button class="tablinks" (click)="openProduct($event, 'categoryThree'); clear(messageType.MSG_TYPE_INFO); clear(messageType.MSG_TYPE_CONFIRMATION);">
      <i class="material-icons custom-margin-right-icon">receipt</i>
      {{ "myProfile.orderDetailSummary" | cxTranslate }}
    </button>
    <button class="tablinks"  (click)="openProduct($event, 'categoryFour'); clear(messageType.MSG_TYPE_INFO); clear(messageType.MSG_TYPE_CONFIRMATION)">
      <i class="material-icons custom-margin-right-icon">access_alarms</i>
      {{ "myProfile.NotificationEmail" | cxTranslate }}
    </button>
  </div>
  <div id="categoryOne"  class="tabcontent">
    <vs-personal-detail (rolesMatrixEvent)="rolesMatrixDisplay($event)"></vs-personal-detail>
  </div>
  <div id="categoryTwo"  class="tabcontent">
    <vs-customer-account></vs-customer-account>
  </div>
  <div id="categoryThree"  class="tabcontent">
    <vs-order-detail></vs-order-detail>
  </div>
  <div id="categoryFour"  class="tabcontent">
    <vs-notify-email></vs-notify-email>
  </div>
</div>
